var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  这里是指令设置，抱歉。您无此权限\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }